// extracted by mini-css-extract-plugin
export default {"CloseButton":"PopupCloseButton_CloseButton__7nrk2"};